<template>
    <div>
        <CCol sm="12">
            <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
            <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
        </CCol>
        <CCol sm="12">
            
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Leave Policies</h3>
                            </CCol>
                            <CCol sm="2">
                                <CButton class="btn-border-blue font-color-0B63F6" @click="openAddSubs"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Download</CButton>
                            </CCol>
                        </CRow>
                                    <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                        <div>
                                            <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                                                <template v-slot:No="{ row }">
                                                                        <label class="custom-12px-500">{{ row.No }}</label>
                                            </template>

                                            <template v-slot:Title="{ row }">
                                                <label class="custom-12px-500">{{ row.Title }}</label>
                                            </template>

                                            <template v-slot:Status="{ row }">
                                                <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
                                            </template>

                                            <template v-slot:Announcer="{ row }">
                                                <label class="custom-12px-500">{{ row.Status }}</label>
                                            </template>

                                            <template v-slot:Created Date="{ row }">
                                                <label class="custom-12px-500">{{ row.CreatedDate }}</label>
                                            </template>

                                            <template v-slot:Updated Date="{ row }">
                                                <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
                                            </template>

                                            <template v-slot:Action="{ row }">
                                                <div class="d-flex"> 
                                                    <img :src="require('@/assets/img/set-view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                                                    <img :src="require('@/assets/img/set-edit.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                                                    <img :src="require('@/assets/img/set-delete.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                                                </div>
                                            </template>
                                                        </v-client-table>
                                                        <div v-else class="no-data-message text-center" style="margin:10%">
                                                <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                                                <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                                <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                                </div>
                                        </div>
                   

                </CCard>
    
                    </div>
                </div>
    
                </CCard>
            </CCol>
    
        </CCol>

        <div v-if="OpenAddEquipment" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Assign Equipment</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddEquipment" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Type</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Details</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date Received</h3>
                                        <CInput type="date" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date Returned</h3>
                                        <CInput type="date" v-model="ShortName" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">File Upload</h3>
                                <div class="text-center p-1">
                                    
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img src="../assets/img/upload1.png" style="max-width:50px;"/>
                                            <img :src="LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload or drag and drop </p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { CInput, CTextarea } from "@coreui/vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            columns: [
                'Name',
                'Relation',
                'Age',
                'Phone',
                'Action'
            ],
            allTableData: [
            ],
            options: {
                perPage: 5,
                pagination: false,
                searchable: false,
                filterable: false,
            },
            isPopupSuccess: false,
            OpenAddEquipment: false,

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },
        openAddEquipment() {
            this.OpenAddEquipment = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenAddEquipment = false;
        },
        closePopupAddEquipment() {
            this.OpenAddEquipment = false;
        },


    }

};
</script>